import { render, staticRenderFns } from "./PeoplePage.vue?vue&type=template&id=7ef7bcc3&scoped=true&"
import script from "./PeoplePage.vue?vue&type=script&lang=js&"
export * from "./PeoplePage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=7ef7bcc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef7bcc3",
  null
  
)

export default component.exports